"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactWebcam = _interopRequireDefault(require("react-webcam"));
var _reactDeviceDetect = require("react-device-detect");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _Icon = _interopRequireDefault(require("../../icons/Icon"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
var CameraContainer = _styledComponents["default"].div.withConfig({
  displayName: "Photo__CameraContainer",
  componentId: "sc-1fp5th1-0"
})(["text-align:center;"]);
var CircleHollow = _styledComponents["default"].div.withConfig({
  displayName: "Photo__CircleHollow",
  componentId: "sc-1fp5th1-1"
})(["border:4px solid ", ";border-radius:50%;cursor:pointer;width:48px;height:48px;margin:auto;"], function (props) {
  return props.theme["white"];
});
var CenterCircle = _styledComponents["default"].div.withConfig({
  displayName: "Photo__CenterCircle",
  componentId: "sc-1fp5th1-2"
})(["border:10px solid ", ";border-radius:50%;cursor:pointer;width:36px;height:36px;background-color:", ";margin:2px auto auto auto;"], function (props) {
  return props.theme["white"];
}, function (props) {
  return props.theme["white"];
});
var UploadImage = _styledComponents["default"].input.attrs(function () {
  return {
    type: "file"
  };
}).withConfig({
  displayName: "Photo__UploadImage",
  componentId: "sc-1fp5th1-3"
})(["display:none;"]);
var UploadLabel = _styledComponents["default"].label.withConfig({
  displayName: "Photo__UploadLabel",
  componentId: "sc-1fp5th1-4"
})(["color:", ";cursor:pointer;position:relative;display:block;top:-50px;font-size:14px;&:hover{color:", ";}"], function (props) {
  return props.theme.link["color"];
}, function (props) {
  return props.theme.link["hover"];
});
var ImageContainer = _styledComponents["default"].div.withConfig({
  displayName: "Photo__ImageContainer",
  componentId: "sc-1fp5th1-5"
})(["width:", "px;height:", "px;margin:auto;overflow:hidden;"], function (props) {
  return props.width;
}, function (props) {
  return props.height;
});
var Img = _styledComponents["default"].img.withConfig({
  displayName: "Photo__Img",
  componentId: "sc-1fp5th1-6"
})(["margin-left:50%;transform:translateX(-50%);", ""], function (props) {
  return props.imageWidth < props.imageHeight ? "max-width: 100%" : "max-height: 100%";
});
var VideoWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Photo__VideoWrapper",
  componentId: "sc-1fp5th1-7"
})(["display:inline-block;overflow:hidden;"]);
var ButtonWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Photo__ButtonWrapper",
  componentId: "sc-1fp5th1-8"
})(["position:relative;top:-65px;padding:0 10px;"]);
var CircleWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Photo__CircleWrapper",
  componentId: "sc-1fp5th1-9"
})(["width:auto;display:inline-block;"]);
var InvisibleButton = _styledComponents["default"].div.withConfig({
  displayName: "Photo__InvisibleButton",
  componentId: "sc-1fp5th1-10"
})(["visibility:hidden;width:48px;height:48px;display:inline-block;float:right;"]);
var StyledDiscardButton = _styledComponents["default"].div.withConfig({
  displayName: "Photo__StyledDiscardButton",
  componentId: "sc-1fp5th1-11"
})(["width:fit-content;border-radius:4px;background-color:", ";color:", ";border:1px solid ", ";position:relative;margin:auto;cursor:pointer;font-weight:bold;padding:5px 10px 5px;"], function (props) {
  return props.theme["white"];
}, function (props) {
  return props.theme["sky-blue"];
}, function (props) {
  return props.theme["sky-blue"];
});
var Photo = function Photo(_ref) {
  var height = _ref.height,
    width = _ref.width,
    enableUpload = _ref.enableUpload,
    readOnly = _ref.readOnly,
    onCapture = _ref.onCapture,
    photo = _ref.photo,
    facingMode = _ref.facingMode,
    videoHeight = _ref.videoHeight,
    videoWidth = _ref.videoWidth,
    clearPhoto = _ref.clearPhoto,
    discardText = _ref.discardText,
    initialUploadText = _ref.initialUploadText;
  var webcamRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    uploaded = _useState2[0],
    setUploaded = _useState2[1];
  var _useState3 = (0, _react.useState)(!photo),
    _useState4 = _slicedToArray(_useState3, 2),
    takePhoto = _useState4[0],
    setTakePhoto = _useState4[1];
  var _useState5 = (0, _react.useState)(facingMode),
    _useState6 = _slicedToArray(_useState5, 2),
    facingModeState = _useState6[0],
    setFacingMode = _useState6[1];
  var imageWidth = 0;
  var imageHeight = 0;
  var capture = (0, _react.useCallback)(function () {
    toggleTakePhoto();
    photo = webcamRef.current.getScreenshot();
    onCapture(photo);
    setUploaded(false);
  }, [webcamRef]);
  var toggleTakePhoto = function toggleTakePhoto() {
    setTakePhoto(!takePhoto);
  };
  var toggleFaceMode = function toggleFaceMode() {
    setFacingMode(!facingModeState);
  };
  var uploadImage = function uploadImage(e) {
    var files = e.target.files;
    var target = {
      photo: null,
      imageWidth: null,
      imageHeight: null
    };
    if (files.length > 0) {
      var file = files[0];
      var reader = new FileReader();
      var image = new Image();
      reader.readAsDataURL(file);
      reader.onload = function () {
        target.photo = reader.result;
        image.src = reader.result;
        image.onload = function () {
          target.imageWidth = width;
          target.imageHeight = height;
          onCapture(target.photo);
          setUploaded(true);
        };
      };
    }
  };
  var videoConstraints = {
    width: videoWidth,
    height: videoHeight,
    facingMode: facingModeState
  };
  if (_reactDeviceDetect.isIOS && (videoConstraints.width !== 640 || videoConstraints.height !== 480)) {
    console.warn("Currently IOS only supports 640x480 video capture anything else will result in a blank div");
  } // This button captures the current webcam view to create a photo

  var CaptureButton = _react["default"].createElement(_react.Fragment, null, _react["default"].createElement(CircleWrapper, null, _react["default"].createElement(CircleHollow, {
    onClick: function onClick() {
      capture();
    }
  }, _react["default"].createElement(CenterCircle, null))), _react["default"].createElement(InvisibleButton, null)); // On mobile devices, we will be able to switch between the front and back cameras

  var SwitchCameraButton = _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faSync,
    color: "white",
    size: "3x",
    style: {
      "float": "left",
      cursor: "pointer",
      visibility: _reactDeviceDetect.isMobile ? "visible" : "hidden"
    },
    onClick: function onClick() {
      toggleFaceMode();
    }
  });
  var VideoView = _react["default"].createElement(VideoWrapper, null, _react["default"].createElement(_reactWebcam["default"], {
    height: height,
    width: width,
    ref: webcamRef,
    style: {
      objectFit: "cover"
    },
    screenshotFormat: "image/jpeg",
    videoConstraints: videoConstraints
  }), !readOnly && _react["default"].createElement(ButtonWrapper, null, SwitchCameraButton, CaptureButton));
  var fileInputRef = (0, _react.useRef)(null);
  var DiscardButton = _react["default"].createElement(StyledDiscardButton, {
    onClick: function onClick() {
      toggleTakePhoto();
      clearPhoto();
    }
  }, _react["default"].createElement(_Icon["default"], {
    iconName: "fa-times-circle",
    styles: {
      hoverColor: null
    }
  }), " ", discardText); // If readonly then just display the photo
  // If not readonly, show the photo with a retake button
  // Retake button will send us back to the Video view

  var PhotoView = _react["default"].createElement(_react.Fragment, null, _react["default"].createElement(ImageContainer, {
    width: width,
    height: height
  }, _react["default"].createElement(Img, {
    src: photo,
    imageWidth: imageWidth,
    imageHeight: imageHeight,
    alt: "Not available"
  }), !readOnly && _react["default"].createElement(ButtonWrapper, null, DiscardButton))); // If photo upload is allowed from the filesystem
  // We will show a clickable link that will open up a file browser

  var allowPhotoUpload = enableUpload && takePhoto && !readOnly;
  var PhotoUpload = _react["default"].createElement(UploadLabel, null, _react["default"].createElement("span", null, initialUploadText), _react["default"].createElement(UploadImage, {
    accept: "image/jpeg",
    onChange: function onChange(e) {
      clearPhoto();
      uploadImage(e);
      toggleTakePhoto();
    }
  }));
  return _react["default"].createElement(CameraContainer, null, takePhoto ? VideoView : PhotoView, allowPhotoUpload && PhotoUpload);
};
Photo.propTypes = {
  /** Width of the photo view */
  width: _propTypes["default"].number,
  /** Height of the photo view */
  height: _propTypes["default"].number,
  /** Width of the video when preparing to take a photo */
  videoWidth: _propTypes["default"].number,
  /** Height of the video when preparing to take a photo */
  videoHeight: _propTypes["default"].number,
  /** Function that executes on photo capture/upload, generally to persist the photo to a store */
  onCapture: _propTypes["default"].func,
  /** String representation of the photo taken/uploaded */
  photo: _propTypes["default"].string,
  /** Should we allow photos uploaded from the file system */
  enableUpload: _propTypes["default"].bool,
  /** Are photos readonly, or can we upload/take new ones */
  readOnly: _propTypes["default"].bool,
  /** Which camera (environment/back, user/front) to use on phone/tablet.  See https://developer.mozilla.org/en-US/docs/Web/API/MediaTrackConstraints/facingMode */
  facingMode: _propTypes["default"].string,
  /** Function for clearing the photo from state or store */
  clearPhoto: _propTypes["default"].func,
  /** Text (String or i18n component) for photo re-upload */
  discardText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  /** Text (String or i18n component) for photo upload  */
  initialUploadText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object])
};
Photo.defaultProps = {
  width: 360,
  height: 360,
  videoWidth: _reactDeviceDetect.isIOS ? 640 : 360,
  videoHeight: _reactDeviceDetect.isIOS ? 480 : 360,
  onCapture: function onCapture() {},
  enableUpload: false,
  readOnly: false,
  facingMode: "user",
  clearPhoto: function clearPhoto() {},
  discardText: "Discard",
  initialUploadText: "Click here to upload a previously taken photo",
  photo: ""
};
var _default = Photo;
exports["default"] = _default;